<template>
  <div class="userGuide">
    <img src="@static/images/userGuide/part1.png" alt="" />
    <img src="@static/images/userGuide/part2.png" alt="" />
    <div class="btn1">
      <img src="@static/images/userGuide/part3.png" alt="" />
      <img
        src="@static/images/userGuide/btn1.png"
        @click="$router.push('/apps/businessCard')"
        alt=""
      />
    </div>
    <!-- <img src="@static/images/userGuide/part4.png" alt="" /> -->
    <!-- <div class="btn2">
      <img src="@static/images/userGuide/btn2.png" alt="" @click="toFriend" />
    </div> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    toFriend() {
      location.href = `${location.origin}/friends/index`;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.userGuide {
  background: rgb(186, 231, 255);
  > img {
    width: 100%;
    display: block;
  }
  .btn1 {
    position: relative;
    img {
      display: block;
      &:nth-of-type(1) {
        width: 100%;
      }
      &:nth-of-type(2) {
        position: absolute;
        width: 535px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 130px;
      }
    }
  }
  .btn2 {
    position: fixed;
    width: 100%;
    bottom: 0;
    background: rgba(132, 214, 247, 0.6);
    height: 250px;
    text-align: center;
    padding-top: 30px;
    img {
      width: 678px;
    }
  }
}
</style>